export default "__VITE_ASSET__8b06bba7__"